<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <van-nav-bar
        title="检验报告"
        left-arrow
        left-text="返回"
        :fixed='true'
        @click-left="onClickLeft"
      />
    </div>
      <div class="head">
      <div class="title_head">
        <div class="title_head_name">{{name}}</div>
        <div class="title_head_age"><span class="geary">年龄：</span>{{age}}{{ageUnit}}</div>
      </div>
      <div class="head_row"><span class="geary">流水号：</span>{{patientSeq}}</div>
    </div>
    <div class="body">

      <div class="listcard" v-if="emptyflag"
           v-for="(item,index) in lissampleList "
           :key="index"
           @click="reportDetialClick(item)">
        <div class="listcard_title line">
          <div class="listcard_title_a">状态</div>
          <div class="listcard_title_b color1">可查看</div>
        </div>
        <div class="listcard_row">
          <div class="listcard_row_a">项目名称</div>
          <div class="listcard_row_b">{{item.itemName}}</div>
        </div>
        <div class="listcard_row">
          <div class="listcard_row_a">样本：</div>
          <div class="listcard_row_b">{{item.sampleTypeName}}</div>
        </div>

        <div class="listcard_row">
          <div class="listcard_row_a">执行科室：</div>
          <div class="listcard_row_b" style="color: #f40"> {{item.execDeptName}}</div>
        </div>
      </div>
      <div v-if="!emptyflag">
        <van-empty image="https://account.kmmds.top/datainfo_pic/error.png" description="暂无报告单" />
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import setOptions from "@/mixins/setOption";
export default {
  mixins: [setOptions],
  data() {
    return {
      lissampleList:[],
      price:null,
      clientId:"",
      name:"",
      age:"",
      ageUnit:"岁",
      patientSeq:"暂无",
      emptyflag:true,
    };
  },
  components: {
    Nav,
  },
  created() {
    this.clientId = this.$route.query.clientId
    this.name = this.$route.query.name
    this.age = this.$route.query.age
    this.getlissample();
  },
  methods: {
    onClickLeft() {
      this.$router.push({
        path:"/reportList",
        query:{
          clientId:this.clientId,
          name:this.name
        }
      });
    },
    async getlissample() {
      // console.log(this.method_depy_type)
      try {//"2020006088"
        let reqData = {
          clientId: this.clientId,
        };
        this.$showLoad();
        let url = "/report/api/querylissamplebyclientid";
        // console.log(R_data)
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          reqData,
          (data) => {
            if(data.data.data.data.length === 0){
              this.emptyflag = false
            }else{
              this.lissampleList=data.data.data.data
              console.log("======>",this.lissampleList);
              this.age = this.lissampleList[0].age
              this.ageUnit = this.lissampleList[0].ageUnit
              this.patientSeq = this.lissampleList[0].patientSeq
              this.lissampleList.forEach((item,index)=>{
                this.price+= Number(item.itemPrice)
              })
            }
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    reportDetialClick(item){
      this.$router.push({
        path:"/hospitalization_C_detail",
        query:{
          testDate:item.testDate,
          deviceId:item.deviceId,
          sampleId:item.sampleId,
          hospitalId:item.hospitalId,
          branchId:item.branchId,
          name:this.name,
          itemName:item.itemName
        }
      })

    }
  },
};
</script>

<style lang="scss" scoped>
  .color1{
    color: #2ed573 !important;
  }
  .color2{
    color: #ff4400 !important;
  }
.main {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  width: 100%;
  background-color: #eee;
  .nav {
    height: 6vh;
    .top {
      height: 6vh;
    }
  }
   .head {
    width: 100%;
    background-color: #5b8df6;
    height: 15vh;
    display: flex;
    flex-direction: column;
    color: white;
    padding: 15px;
    .title_head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 6vh;
      .title_head_name {
        font-size: 25px;
      }
      .title_head_age {
        font-size: 14px;
      }
    }
    .head_row {
      font-size: 14px;
      line-height: 4vh;
      color: #ffffff;
    }
  }
  .body {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 94vh;
    overflow: scroll;
    .listcard {
      display: flex;
      flex-direction: column;
      background-color: white;
      width: 100%;
      margin: 0px auto;
      margin-bottom: 8px;
    }
    .listcard_title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 24px;
      width: 95%;

      padding: 10px;
      margin: 0px auto;
      .listcard_title_a {
        font-size: 16px;
      }
      .listcard_title_b {
        font-size: 14px;
        color: #999;
      }
    }
    .listcard_row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 15px;
      width: 95%;

      padding: 10px;
      margin: 0px auto;
      .listcard_row_a {
        font-size: 14px;
        color: #999;
      }
      .listcard_row_b {
        font-size: 14px;
      }
    }
    .listcard_money {
      line-height: 35px;
      font-size: 14px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      width: 95%;
      text-align: end;
      .moneycolor {
        color: #5b8df6;
        font-weight: bolder;
        font-size: 18px;
      }
    }
  }
  
}
</style>
